import Model from '../../ModelBinding/Model';
import ProductCollection from './ProductCollection';
import dayjs from 'dayjs';
import TechnicalDetailValueCollection from '../TechnicalDetailValue/TechnicalDetailValueCollection';
import ProductSubtype from '../ProductSubtype/ProductSubtype';
import TagCollection from '../Tag/TagCollection';
import OutputFormatCollection from '../OutputFormat/OutputFormatCollection';
import OptionCollection from '../Option/OptionCollection';
import RoleCollection from '../Role/RoleCollection';

export default class Product extends Model {
  public product_type?: string;
  public name?: string;
  public technical_details?: TechnicalDetailValueCollection;
  public created_at?: dayjs.Dayjs;
  public updated_at?: dayjs.Dayjs;
  public product_subtype_id?: string;
  public subtype?: ProductSubtype;
  public tags?: TagCollection;
  public output_formats?: OutputFormatCollection;
  public quantity_min?: number;
  public quantity_max?: number;
  public quantity_out?: number;
  public offer_item_id?: string;
  public customized?: boolean;
  public edition_grade?: string;
  public post_productions?: RoleCollection;
  public linked_options?: OptionCollection;
  public has_pre_qc?: boolean;

  bind() {
    this.product_type = this.getStringAttribute('product_type');
    this.product_subtype_id = this.getStringAttribute('product_subtype_id');
    this.subtype = this.getRelation('subtype', ProductSubtype) as ProductSubtype;
    this.tags = this.getRelationCollection('tags', TagCollection) as TagCollection;
    this.output_formats = this.getRelationCollection('output_formats', OutputFormatCollection) as OutputFormatCollection;
    this.offer_item_id = this.getStringAttribute('offer_item_id');
    this.name = this.getStringAttribute('name');
    this.created_at = this.getDateAttribute('created_at');
    this.updated_at = this.getDateAttribute('updated_at');
    this.quantity_min = this.getIntAttribute('quantity_min');
    this.quantity_max = this.getIntAttribute('quantity_max');
    this.quantity_out = this.getIntAttribute('quantity_out');
    this.technical_details = this.getRelationCollection('technical_details', TechnicalDetailValueCollection) as TechnicalDetailValueCollection;
    this.customized = this.getBooleanAttribute('customized');
    this.edition_grade = this.getStringAttribute('edition_grade');
    this.post_productions = this.getRelationCollection('post_productions', RoleCollection) as RoleCollection;
    this.linked_options = this.getRelationCollection('linked_options', OptionCollection) as OptionCollection;
    this.has_pre_qc = this.getBooleanAttribute('has_pre_qc');
  }

  static getCollection() {
    return ProductCollection;
  }

  get categories() {
    if (!this.tags) return new TagCollection();
    return this.tags.filter(tag => tag.name === 'CATEGORY');
  }

  toString() {
    if (!this.subtype) return this.name;
    return `${this.name} (${this.subtype.product_type_code})`;
  }
}
